export default "__VITE_ASSET__qla1$seP__"